module.exports = __webpack_public_path__ + "img/icon_zhifu_cg.84120fc1.png";